import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box, LinearProgress } from '@mui/material';
import { animations } from 'src/theme/animations';

const RacoonLoading = ({ message }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backdropFilter: 'blur(8px)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 3,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', animation: animations.pulse }}>
        <img src="/assets/logo.svg" alt="Loading" style={{ width: '250px' }} />
      </Box>
      {message && (
        <>
          <Typography
            variant="h6"
            sx={{
              color: 'primary.main',
              fontWeight: 500,
              textAlign: 'center',
              maxWidth: '600px',
            }}
          >
            {message}
          </Typography>
          <Box sx={{ width: '300px', mt: 1 }}>
            <LinearProgress
              sx={{
                height: 6,
                borderRadius: 3,
                backgroundColor: (theme) => theme.palette.grey[200],
                '& .MuiLinearProgress-bar': {
                  borderRadius: 3,
                },
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

RacoonLoading.propTypes = {
  message: PropTypes.string,
};

export default RacoonLoading;
